export const getContainerMaxWidth = (theme, isContained) => {
    if (!isContained) {
        return 'auto';
    }
    const containerSize = isContained === true ? 'lg' : isContained;
    return theme.breakpoints.values[containerSize];
};
